import { render } from "./GigsToMrrRetainersBlog.vue?vue&type=template&id=d85c48a4&scoped=true"
import script from "./GigsToMrrRetainersBlog.vue?vue&type=script&lang=js"
export * from "./GigsToMrrRetainersBlog.vue?vue&type=script&lang=js"

import "./GigsToMrrRetainersBlog.vue?vue&type=style&index=0&id=d85c48a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d85c48a4"]])

export default __exports__